module.exports = __webpack_public_path__ + "static/media/copy_grey_img.76347756.svg";